const initialState = {
  list: {
    isLoading: false,
    error: '',
    data: [],
  },
  update: {
    isLoading: false,
    error: '',
  },
  add: {
    isLoading: false,
    error: '',
  },
  show: {
    isLoading: false,
    error: '',
    data: {},
  },
  info: {
    isLoading: false,
    error: '',
    data: {},
  },
};

export default initialState;
